/** @format */

import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import constantsReducer from '../common/dropdowns/Api/constantSlice';
import adminReducer from '../features/admin/adminSlice';
import applicantReducer from '../features/applicant/ApplicantSlice';
import homeReducer from '../features/home/homeSlice';
import loginReducer from '../features/login/loginSlice';

export const store = configureStore({
  reducer: {
    applicant: applicantReducer,
    constants: constantsReducer,
    admin: adminReducer,
    login: loginReducer,
    home: homeReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
